import ProductCategoryForm from './ProductCategoryForm'
export {ProductCategoryForm}
export default ProductCategoryForm
